import {
  createComponentMapperModel,
  createUDPUiTypeMapper,
} from '@wix/editor-elements-integrations';
import {
  props,
  css,
  sdkData,
  stateRefs,
} from '../../../StylableButton/viewer/StylableButton.mapper';

export const uiType = createUDPUiTypeMapper('Default', 'HamburgerCloseButton');

export default createComponentMapperModel({
  stateRefs,
  props,
  css,
  sdkData,
  uiType,
});
